import React, { ComponentType } from 'react'
import { configuration } from './configuration'
import { Items } from './typings/Config'
import { AppWrapper } from './components/App/AppWrapper'
import { UserProvider } from './components/App/UserProvider'

export interface App {
  name: string
  visibleName: string
  iconUrl: string
  url: string
  component: ComponentType
  submenus?: {
    items?: Items[]
    name: string
    url: string
    icon?: ComponentType
  }[]
}

export const configs = () => {
  const App = () => {
    return (
          <UserProvider>
            <AppWrapper />
          </UserProvider>
    )
  }

  const config: App = {
    ...configuration,
    component: App
  }

  return config
}